import { useTranslations } from 'next-intl'

export function UserNameLabel({ children, ...props }: React.ComponentProps<'span'>) {
  const t = useTranslations('social-feed.components.user_name_label')
  return <span {...props}>{children || t('anonymous_user')}</span>
}
